import { Select as ChakraSelect } from '@chakra-ui/react';

import { SelectProps } from './select.props';

export const Select = ({
    customTriggerContent,
    isClearable = false,
    valueTextWeight = 'bold',
    collection,
    contentProps = {},
    controlProps = {},
    itemProps = {},
    triggerProps = {},
    positioning = {},
    ...props
}: SelectProps): JSX.Element => {
    return (
        <ChakraSelect.Root
            collection={collection}
            positioning={{ offset: { mainAxis: -1 }, flip: false, sameWidth: true, ...positioning }}
            {...props}
        >
            <ChakraSelect.HiddenSelect />
            <ChakraSelect.Control {...controlProps}>
                <ChakraSelect.Trigger {...triggerProps}>
                    {customTriggerContent}
                    <ChakraSelect.ValueText fontWeight={valueTextWeight} />
                </ChakraSelect.Trigger>
                <ChakraSelect.IndicatorGroup>
                    <ChakraSelect.Indicator />
                    {isClearable ? <ChakraSelect.ClearTrigger /> : null}
                </ChakraSelect.IndicatorGroup>
            </ChakraSelect.Control>

            <ChakraSelect.Positioner>
                <ChakraSelect.Content {...contentProps}>
                    {collection.items.map(item => (
                        <ChakraSelect.Item item={item} key={item.value} {...itemProps}>
                            {item.label}
                            <ChakraSelect.ItemIndicator />
                        </ChakraSelect.Item>
                    ))}
                </ChakraSelect.Content>
            </ChakraSelect.Positioner>
        </ChakraSelect.Root>
    );
};
